import { default as styled } from 'styled-components'
import { respondBelow } from '@rhinofi/dvf-shared-ui/lib/utils/respondTo'

export const Main = styled.div`
  position: relative;
  background: ${({ theme }) => theme.background};
  font-family: ${(props) => props.theme.defaultFont};
  color: ${(props) => props.theme.textPrimary};
  overflow: auto;
  min-width: unset;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: stretch;

  .simplebar-scrollbar:before {
    background: ${(props) => props.theme.scrollbar};
  }

  button {
    font-family: ${(props) => props.theme.defaultFont};
  }

  @media ${respondBelow('xxs')} {
    min-width: 0;
    max-width: 100vw;
    width: 100%;
  }
`
